import { useState, useRef, useEffect } from "react"
import ProcessingAnimation from "../Processing/ProcessingAnimation"

const Preview = ({ cachedVideoBlob, isCaching }) => {
  const isChristmas = true
  const containerRef = useRef(null)
  const [parentHeight, setParentHeight] = useState(null)

  useEffect(() => {
    const measure = () => {
      if (!containerRef.current) return
      const el = containerRef.current
      const h = el.clientHeight
      setParentHeight(h)
      // print to console as requested
      console.log("Measured containerRef height (px):", h)
    }
    // initial measure
    measure()
  }, [])
  return (
    <div
      css={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexGrow: 1,
      }}
    >
      <div
        ref={containerRef}
        css={{
          position: "relative",
          borderRadius: 8,
          background: "rgba(0, 0, 0, 0.20)",
          boxShadow: "0px 0px 16px 0px #083EB5",

          ...(isChristmas && {
            border: "1px solid #B5DDE6",
            backdropFilter: "blur(1px)",
            background: "rgba(0, 0, 0, 0.20)",
            boxShadow: "0 0 24px 0 rgba(0, 234, 129, 0.80)",
          }),

          height: "100%",
          width: "100%",
          color: "gray",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isCaching ? (
          <ProcessingAnimation />
        ) : (
          <video
            width="100%"
            controls
            autoPlay={false}
            css={{
              borderRadius: 8,
              objectFit: "contain",
              height: parentHeight - 1,
            }}
          >
            <source
              src={URL.createObjectURL(cachedVideoBlob)}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </div>
  )
}

export default Preview
